import { Route, Routes} from "react-router-dom";
import Inicio from './pages/Inicio';
import Marcas from './pages/Marcas';
import Contacto from './pages/Contacto';
import Servicios from './pages/Servicios';
import SobreNosotros from './pages/SobreNosotros';
import Error from "./pages/Error";
import ProductosServicios from "./pages/ProductosServicios";
import DetalleProductoServicio from "./pages/DetalleProductoServicio";
import Carrito from "./pages/Carrito";
import Login from "./pages/Login";
import Registro from "./pages/Registro";
import PanelAdministracion from "./pages/PanelAdministracion";
import PoliticasDeEnvio from "./pages/PoliticasDeEnvio";
import PoliticasDeDevoluciones from "./pages/PoliticasDeDevoluciones";
import TerminosYCondiciones from "./pages/TerminosYCondiciones";
import PoliticaDePrivacidad from "./pages/PoliticasDePrivacidad";
import CategoriaABM from "./pages/CategoriaABM";
import ProductoABM from "./pages/ProductoABM";
import MarcaABM from "./pages/MarcaABM";
import ServicioABM from "./pages/ServicioABM";
import AuthComponent from "./components/Helper/AuthComponent";

function App() {
  return (
    
    <Routes>
    <Route path="/" element={<Inicio />}/>
    <Route path="/marcas" element={<Marcas />}/>
    <Route path="/post-venta" element={<Servicios />}/>
    <Route path="/contacto" element={<Contacto />}/>
    <Route path="/sobrenosotros" element={<SobreNosotros />}/>
      <Route path="/productos" element={<ProductosServicios />} />
      <Route path="/productos/:marca" element={<ProductosServicios />} />
      <Route path="/post-venta/:servicio" element={<ProductosServicios />} />
      <Route path="/detalle/:codigo" element={<DetalleProductoServicio/> } />
      <Route path="/carrito" element={<Carrito/> } />
      <Route path="/envios" element={<PoliticasDeEnvio/> } />
      <Route path="/devoluciones" element={<PoliticasDeDevoluciones/> } />
      <Route path="/terminos" element={<TerminosYCondiciones/> } />
      <Route path="/privacidad" element={<PoliticaDePrivacidad/> } />
      <Route path="/agroh_panel" element={<Login/> } />
      <Route path="/registro" element={<Registro />} />
      <Route path="/panel_administracion" element={<AuthComponent><PanelAdministracion/></AuthComponent> } />
      <Route path="/formulario-categoria" element={<AuthComponent><CategoriaABM/></AuthComponent> } />
      <Route path="/formulario-marca" element={<AuthComponent><MarcaABM/></AuthComponent> } />
      <Route path="/formulario-producto" element={<AuthComponent><ProductoABM/></AuthComponent> } />
      <Route path="/formulario-servicio" element={<AuthComponent><ServicioABM/> </AuthComponent>} />
    <Route path="*" element={<Error />}/>
      </Routes>
      );
}

export default App;
